import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/relationship-scores/new/loading';

export const Route = createFileRoute('/_private/settings/relationship-scores/new')({
  component: Loading,
});
